module.exports = __webpack_public_path__ + "img/icon-diona.1c65458a.webp";